/**
 * @file Web Gallery Blog related fragments.
 */

import gql from 'graphql-tag';

import { PhotoUrlTypeFields } from '../../../../graphql/fragments/album';

export const BlogPostLinkDetails = gql`
  fragment BlogPostLinkDetails on IBlogPostLink {
    ... on IRecord {
      id
    }
    ... on BlogPostAlbumFolderLink {
      album_folder {
        id
        name
      }
    }
    ... on BlogPostAlbumLink {
      album {
        id
        name
      }
    }
    ... on BlogPostAlbumPhotoGroupLink {
      album_photo_group {
        id
        name
        album {
          id
        }
      }
    }
    ... on IBlogPostLink {
      link_type
    }
  }
`;

export const BlogPostListingDetails = gql`
  fragment BlogPostListingDetails on BlogPost {
    id
    created_at
    updated_at
    title
    excerpt(word_length: 20)
    is_viewed
    cover_photo {
      id
      thumbnail_urls(ignore_watermark: true) {
        ...PhotoUrlTypeFields
      }
    }
    album_folder {
      id
    }
    blog_post_links(slice: { limit: 1 }) {
      total
      records {
        ...BlogPostLinkDetails
      }
    }
  }
  ${PhotoUrlTypeFields}
  ${BlogPostLinkDetails}
`;

export const BlogPostDetails = gql`
  fragment BlogPostDetails on BlogPost {
    ...BlogPostListingDetails
    content
    blog_post_links(slice: { limit: 1 }) {
      total
      records {
        ...BlogPostLinkDetails
      }
    }
  }
  ${BlogPostListingDetails}
  ${BlogPostLinkDetails}
`;
